import url from 'url'
import router from '@/router'
import _ from 'lodash'
import querystring from 'querystring'
import { getMembership } from '@/libs/cookie-storage'
import defaultImg from '@/assets/images/hockey.png'

export { defaultImg }

export const ImageFormat = {
  imageView: function (hash, w, h, mode, format) {
    mode = mode || 1
    let url = hash
    if (!hash) return false
    if (!hash.match(/^(http|https):/i)) {
      url = varConfig.qiniuCdn + '/' + hash
    }
    if (url.match(/qiniucdn\.com/i) || url.match(/image\.bjh\.snsports\.cn/i) || url.match(/s\.bjhockey\.org/i)) {
      if (url.indexOf('?') < 0) {
        url = url + '?imageView2/' + mode + '/w/' + w + '/h/' + h
        if (format) {
          url += '/format/' + format
          if (format === 'jpg') {
            url += '/interlace/1'
          }
        }
      }
    }
    return url
  },
  squareImageView: function(hash, size, mode, format) {
    return this.imageView(hash, size, size, mode, format)
  },
  squareImageView1: function(hash, height, width, mode, format) {
    return this.imageView(hash, height, width, mode, format)
  }
}

export const ConstConfig = {
  apiPath: '/api',
  authApiPath: '/api_passport',
  qiniuUpload: 'http://up-z1.qiniup.com'

}

export let varConfig = {
  qiniuCdn: process.env.QINIU_CDN,
  banmaApi: process.env.BANMA_API,
  wxAppId: process.env.APPID,
  payUrl: process.env.PAYURL,
}

console.log(window.location.href)
if (enableHttps()) {
  if (process.env.NODE_ENV === 'production') {
    varConfig.banmaApi = 'https://api.snsports.cn'
    varConfig.qiniuCdn = 'https://images.banmabang.cn'
  } else {
    varConfig.banmaApi = 'https://test.api.snsports.cn'
    varConfig.qiniuCdn = 'https://images.banmabang.cn'
  }
}

function enableHttps() {
  return window.location.protocol === 'https:'
}

export const AppType = {
  isInWeChat: function() { // 判断是否是在微信内打开
    return /MicroMessenger/i.test(window.navigator.userAgent)
  },
  isInQQ: function() { // 判断是否是在微信内打开
    return /MicroMessenger/i.test(window.navigator.userAgent)
  },
  isInApp: function() { // 包含bmb and bmLive
    return /Banma/i.test(window.navigator.userAgent)
  },
  isInBmApp: function() {
    return /Banma/i.test(window.navigator.userAgent) && !(/BanmaLive/i.test(window.navigator.userAgent))
  },
  isInLiveApp: function() {
    return /BanmaLive/i.test(window.navigator.userAgent)
  },
  isInAndroid: function() {
    return /Android/i.test(window.navigator.userAgent)
  }
}


export function getSearchParams (absUrl) {
  absUrl = absUrl || window.location.href
  let query = url.parse(absUrl).search
  query = query.replace(/^#[ -~]+\?/, '')
  return querystring.parse(query)
}

export function getValidMembership (member) {
  let validMemberShip = null
  const memberShip = member || getMembership()
  if (!memberShip) {
    router.replace({name: 'Login'})
    return
  }
  if (memberShip.nextMembershipYear && memberShip.nextMembershipYear.registerBegin > 0) { // 下一年注册生效
    validMemberShip = memberShip.nextMembershipYear
  } else {
    validMemberShip = memberShip && memberShip.currentMembershipYear
  }
  return validMemberShip
}

export function mapMemberType (id) {
  const list = [
    {id: 0, name: '会员单位', type: 'member'},
    {id: 1, name: '运动员', type: 'player'},
    {id: 2, name: '教练员', type: 'coach'},
    {id: 3, name: '场内裁判员', type: 'in-referee'},
    {id: 4, name: '场外裁判员', type: 'out-referee'}
  ]
  return _.find(list, function (item) {
    return  item.id === id
  })
}

export function documentVerification(code) {
  //身份证号合法性验证
  //支持15位和18位身份证号
  //支持地址编码、出生日期、校验位验证
  var city={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外 "};
  var row={
    'pass':true,
    'msg':'验证成功'
  };
  if(!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(code)){
    row={
      'pass':false,
      'msg':'身份证号格式错误'
    };
  }else if(!city[code.substr(0,2)]){
    row={
      'pass':false,
      'msg':'身份证号地址编码错误'
    };
  }else{
    //18位身份证需要验证最后一位校验位
    if(code.length == 18){
      code = code.split('');
      //∑(ai×Wi)(mod 11)
      //加权因子
      var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
      //校验位
      var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
      var sum = 0;
      var ai = 0;
      var wi = 0;
      for (var i = 0; i < 17; i++)
      {
        ai = code[i];
        wi = factor[i];
        sum += ai * wi;
      }
      if(parity[sum % 11] != code[17].toUpperCase()){
        row={
          'pass':false,
          'msg':'身份证号校验位错误'
        };
      }
    }
  }
  return row;
}

export function isWeiXin(){ // 判断是否是在微信内打开
  return /MicroMessenger/i.test(window.navigator.userAgent);
}

export function getSearchQueryParams(url) {
  // This function is anonymous, is executed immediately and
  // the return value is assigned to QueryString!
  var queryString = '';
  if (url) {
    var urlParts = url.split('?');
    if (urlParts.length == 3) {//Url中可能有两个问号，hash中也可能有问号，这种情况，将两部分参数拼在一起处理。
      queryString = urlParts[1].replace(/#.*/, '') + '&' + urlParts[2];
    } else if (urlParts.length == 2) {
      queryString = urlParts[1];
    }
  } else {
    queryString = uriParse().search;
  }

  var query_string = {};
  var vars = queryString.split("&");
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) continue;
    var pair = vars[i].split("=");
    // If first entry with this name
    if (typeof query_string[pair[0]] === "undefined") {
      query_string[pair[0]] = decodeURIComponent(pair[1]);
      // If second entry with this name
    } else if (typeof query_string[pair[0]] === "string") {
      query_string[pair[0]] = [query_string[pair[0]], decodeURIComponent(pair[1])];
      // If third or later entry with this name
    } else {
      query_string[pair[0]].push(decodeURIComponent(pair[1]));
    }
  }
  return query_string;
}

export function IsOnPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = ["Android", "iPhone",
    "SymbianOS", "Windows Phone",
    "iPad", "iPod"];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

function uriParse(uri) {
  uri = uri || window.location.href;
  var location = {
    absUrl: window.location.href,
    referUrl: document.referrer,
    domain: window.location.hostname,
    protocol: window.location.protocol,
    port: window.location.port,
    path: window.location.pathname,
    search: window.location.search ? window.location.search.substring(1) : '',
    hash: window.location.hash,
    title: document.getElementsByTagName("title")[0].innerHTML,
    userAgent: navigator.userAgent
  };
  return location
}

export function getBirthdayFromIdCard(idCard) {
  let birthday = ''
  if (idCard != null && idCard !== '') {
    if (idCard.length === 15) {
      birthday = '19' + idCard.substr(6, 6)
    } else if (idCard.length === 18) {
      birthday = idCard.substr(6, 8)
    }
    birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-')
  }
  return birthday
}



// WEBPACK FOOTER //
// ./src/utils/index.js